export const Namespace = 'SharedContent';
export enum SharedContentAction {
    CollapseShares = 'COLLAPSE_SHARES',
    ExpandShares = 'EXPAND_SHARES',
    OpenLibrary ='OPEN_LIBRARY'
};


// WEBPACK FOOTER //
// ./src/sharebase-app/components/sharedContent/sharedContent.actions.ts